import type { KitIcon } from "../kit/kit-model.ts";

/**
 * "Novidades" do menu (F80, ui-a "LATEST NEWS"): as últimas mudanças que o jogador vê, escritas à mão a
 * partir do `CHANGELOG.md` (cada uma cita a feature de origem, conferida no teste). Sem imagens: o ícone do
 * kit no lugar da miniatura do mockup. Ao fechar uma feature que muda o jogo, entra uma linha aqui.
 */
export interface NewsItem {
  /** Feature ou fase do `CHANGELOG.md` (`F80`, `Fase 13`). */
  feature: string;
  title: string;
  /** Data ISO (`2026-10-08`). */
  date: string;
  text: string;
  icon: KitIcon;
}

export const NEWS: readonly NewsItem[] = [
  { feature: "F121", title: "Esqueceu a senha?", date: "2026-10-13", text: "Peça um link no login do menu ou no site e crie uma senha nova; o link vale por uma hora.", icon: "icone-conta" },
  { feature: "Fase 15", title: "Mar vivo e baús que brilham", date: "2026-10-12", text: "Ondas que quebram na praia e molham a areia; os baús de saque brilham em dourado até você abri-los.", icon: "icone-tela" },
  { feature: "Fase 14", title: "Golpes de energia", date: "2026-10-12", text: "Meia-lua na cor da classe, faíscas em todo acerto, cristais no crítico e poeira nos pés.", icon: "categoria-armas" },
  { feature: "Fase 13", title: "Luz de cinema", date: "2026-10-12", text: "Sombra do sol, luz indireta, névoa quente e o herói de vidro na cor da classe; opções novas em Gráficos.", icon: "icone-opcoes" },
  { feature: "F85", title: "Cada classe, uma cor", date: "2026-10-08", text: "Escolha a classe vendo os personagens em 3D (mouse, teclado ou controle); a UI acende na cor dela.", icon: "icone-classe" },
  { feature: "F81", title: "HUD novo", date: "2026-10-08", text: "Bússola, minimapa redondo, objetivos, avisos e o cartão de interagir com a tecla.", icon: "hud-mapa" },
  { feature: "F80", title: "Menu e pausa novos", date: "2026-10-08", text: "Esc abre a pausa na partida (o mundo não para), e as opções ganharam abas.", icon: "icone-jogar" },
  { feature: "F76", title: "Status à vista", date: "2026-10-08", text: "Os status do grupo nos quadros, o Exposto na barra do chefe e o chevron do dano recebido.", icon: "aba-habilidades" },
  { feature: "F77", title: "Regras ajustadas", date: "2026-10-07", text: "Escudo Erguido só sem atacar, o Brado protege quem grita (−20 % de dano) e a quebra de postura abre o Exposto.", icon: "categoria-armas" },
  { feature: "F75", title: "Cores fiéis", date: "2026-10-07", text: "O vermelho é só do chefe; cada jogador na cor do seu slot, no mapa e nas construções.", icon: "icone-tela" },
];

/** Versão do jogo no rodapé do menu (a do `package.json` do cliente, conferida no teste). */
export const GAME_VERSION = "0.3.0";

/** As `n` novidades mais recentes (data decrescente; empate, a ordem da lista). */
export function latestNews(items: readonly NewsItem[], n: number): NewsItem[] {
  return items
    .map((item, i) => ({ item, i }))
    .sort((a, b) => (a.item.date === b.item.date ? a.i - b.i : a.item.date < b.item.date ? 1 : -1))
    .slice(0, Math.max(0, n))
    .map(({ item }) => item);
}

const MONTHS = ["jan.", "fev.", "mar.", "abr.", "maio", "jun.", "jul.", "ago.", "set.", "out.", "nov.", "dez."];

/** Data curta em português (`8 out. 2026`), sem depender do `Intl` do navegador. */
export function newsDate(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  const month = m ? MONTHS[Number(m[2]) - 1] : undefined;
  if (!m || !month) return iso;
  return `${Number(m[3])} ${month} ${m[1]}`;
}
